import { render, staticRenderFns } from "./ActivityTable.vue?vue&type=template&id=2547ffb4"
import script from "./ActivityTable.vue?vue&type=script&lang=ts"
export * from "./ActivityTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports